<template>
    <div>
        <el-select v-model="selected" size="mini" @change="onChange">
            <el-option v-for="option in options" :key="option.sno" :value="option.mno" :label="option.cmpnam" class="acc-center-company-switch-item">
                <div class="main clearfix">
                    <div>{{ option.cmpnam }}</div>
                    <div class="sub">{{ option.bsn }}（{{ getGrpNoName(option.grP_NO) }}）</div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected: null,
            options: [],
        };
    },
    async mounted() {
        const currentLoginCmpbsn = localStorage.getItem('accLoginBsn');

        const resp = await this.$api({
            url: 'HomePage/GetAvailableCompanyOptions',
            method: 'GET',
        });

        this.options = resp.data.options;
        const FOUND = this.options.find((o) => o.bsn === currentLoginCmpbsn);
        this.selected = FOUND.mno;
    },
    methods: {
        onChange(mno) {
            window.location.href = `${process.env.VUE_APP_ACC_CENTER_URL}switch-login-landing-page/${mno}`;
        },
        getGrpNoName(grpNo) {
            switch (grpNo) {
            case 'OT1':
                return '會計查帳';
            case 'OT2':
                return '財務顧問';
            case 'OT3':
                return '小秘書';
            case 'OT4':
                return '公司會計';
            case 'OT5':
                return '會計記帳';
            case 'OT6':
                return '歷史查帳';
            default:
                return '--';
            }
        },
    },
};
</script>

<style lang="scss">
.ah-el-select-staff {
    .el-input {
        min-width: 260px;
    }

    .el-input > input {
        cursor: text;
    }
}

.el-select-dropdown__item.acc-center-company-switch-item {
    padding-top: 3px;
    height: 59px;

    .main {
        display: block;
    }

    .sub {
        position: relative;
        top: -5px;
        font-size: 9pt;
        color: #ccc;
        height: 15px;
        line-height: 15px;
        font-weight: normal;
    }

    .clearfix:before,
    .clearfix:after {
        content: "";
        display: table;
    }

    .clearfix:after {
        clear: both;
    }

    .clearfix {
        *zoom: 1;
        /*For IE 6&7 only*/
    }
}
</style>
